import { SelectOption } from "../components/modals/forms/inputs/SelectInput/SelectInput";
import { IBrand } from "../types/brands.type";
import { ICategory } from "../types/category.type";
import { IClient } from "../types/clients.type";
import { OrderStatus } from "../types/order.type";
import { IProductType } from "../types/productType.type";
import { ResourceType } from "../types/resources.type";
import { ISupplier } from "../types/suppliers.type";
import { WarehouseStatus } from "../types/warehouse.type";
import { getPaymentStatus } from "./getPaymentStatus";
import { getStatusWarehouse } from "./getWarehouseStatus";

export const createSelectorSupplier = (data: ISupplier[]): SelectOption[] => {
  return data.map((item) => ({ value: item.id, label: item.name }));
};

export const createSelectorBrands = (data: IBrand[]): SelectOption[] => {
  const brands: SelectOption[] = [{ value: "none", label: "Будь який" }];
  const selection = data.map((item) => ({ value: item.id, label: item.name }));
  return [...brands, ...selection];
};

export const createSelectorTypes = (data: IProductType[]): SelectOption[] => {
  const brands: SelectOption[] = [{ value: "none", label: "Будь який" }];
  const selection = data.map((item) => ({ value: item.id, label: item.name }));
  return [...brands, ...selection];
};

export const createSelectorCategrory = (data: ICategory[]): SelectOption[] => {
  const brands: SelectOption[] = [{ value: "none", label: "Будь який" }];
  const selection = data.map((item) => ({ value: item.id, label: item.name }));
  return [...brands, ...selection];
};

export const resourceTypeSelector: SelectOption[] = [
  {
    value: ResourceType.ACCESSOIRES,
    label: "Комплектуючі",
  },
  {
    value: ResourceType.CONSUMERS,
    label: "Розсхідники",
  },
];

export const resourceTypeFilterSelector: SelectOption[] = [
  {
    value: "none",
    label: "Будь-який",
  },
  {
    value: ResourceType.ACCESSOIRES,
    label: "Комплектуючі",
  },
  {
    value: ResourceType.CONSUMERS,
    label: "Розсхідники",
  },
];

export const warehouseStatusSelector: SelectOption[] = [
  {
    value: WarehouseStatus.IN_STOCK,
    label: getStatusWarehouse(WarehouseStatus.IN_STOCK),
  },
  {
    value: WarehouseStatus.IS_EXPECTED,
    label: getStatusWarehouse(WarehouseStatus.IS_EXPECTED),
  },
  {
    value: WarehouseStatus.SHORTAGE,
    label: getStatusWarehouse(WarehouseStatus.SHORTAGE),
  },
];

export const warehouseStatusFilterSelector: SelectOption[] = [
  {
    value: "none",
    label: "Будь-який",
  },
  {
    value: WarehouseStatus.IN_STOCK,
    label: getStatusWarehouse(WarehouseStatus.IN_STOCK),
  },
  {
    value: WarehouseStatus.IS_EXPECTED,
    label: getStatusWarehouse(WarehouseStatus.IS_EXPECTED),
  },
  {
    value: WarehouseStatus.SHORTAGE,
    label: getStatusWarehouse(WarehouseStatus.SHORTAGE),
  },
];

export const orderStatusSelector: SelectOption[] = [
  {
    value: OrderStatus.PACKED,
    label: getPaymentStatus(OrderStatus.PACKED),
  },
  {
    value: OrderStatus.SHIPPED,
    label: getPaymentStatus(OrderStatus.SHIPPED),
  },
  {
    value: OrderStatus.DELIVERED,
    label: getPaymentStatus(OrderStatus.DELIVERED),
  },
  {
    value: OrderStatus.RECEIVED,
    label: getPaymentStatus(OrderStatus.RECEIVED),
  },
  {
    value: OrderStatus.CANCELED,
    label: getPaymentStatus(OrderStatus.CANCELED),
  },
];

export const orderStatusFilterSelector: SelectOption[] = [
  {
    value: "none",
    label: "All",
  },
  {
    value: OrderStatus.PENDING,
    label: getPaymentStatus(OrderStatus.PENDING),
  },
  {
    value: OrderStatus.PAID,
    label: getPaymentStatus(OrderStatus.PAID),
  },
  {
    value: OrderStatus.PREPARING,
    label: getPaymentStatus(OrderStatus.PREPARING),
  },
  {
    value: OrderStatus.PACKED,
    label: getPaymentStatus(OrderStatus.PACKED),
  },
  {
    value: OrderStatus.SHIPPED,
    label: getPaymentStatus(OrderStatus.SHIPPED),
  },
  {
    value: OrderStatus.DELIVERED,
    label: getPaymentStatus(OrderStatus.DELIVERED),
  },
  {
    value: OrderStatus.RECEIVED,
    label: getPaymentStatus(OrderStatus.RECEIVED),
  },
];

export const createClientsOrderSelector = (
  clients: IClient[]
): SelectOption[] => {
  const selector: SelectOption[] = clients.map((item) => ({
    value: item.id,
    label: `${item.fullName} ${item.phone}`,
  }));

  return [{ value: "new", label: "New client" }, ...selector];
};

export const clientTypeSelector: SelectOption[] = [
  { value: "retail", label: "Retail" },
  { value: "wholesale", label: "Wholesale" },
];

export const clientTypeFilterSelector: SelectOption[] = [
  { value: "none", label: "All" },
  { value: "retail", label: "Retail" },
  { value: "wholesale", label: "Wholesale" },
];

export const phoneOrderFirstsStatusSelector: SelectOption[] = [
  {
    value: OrderStatus.PENDING,
    label: getPaymentStatus(OrderStatus.PENDING),
  },
  {
    value: OrderStatus.PAID,
    label: getPaymentStatus(OrderStatus.PAID),
  },
  {
    value: OrderStatus.CANCELED,
    label: getPaymentStatus(OrderStatus.CANCELED),
  },
];

export const phoneOrderSecondStatusSelector: SelectOption[] = [
  {
    value: OrderStatus.PACKED,
    label: getPaymentStatus(OrderStatus.PACKED),
  },

  {
    value: OrderStatus.SHIPPED,
    label: getPaymentStatus(OrderStatus.SHIPPED),
  },
  {
    value: OrderStatus.CANCELED,
    label: getPaymentStatus(OrderStatus.CANCELED),
  },
];

export const phoneOrderThirdStatusSelector: SelectOption[] = [
  {
    value: OrderStatus.SHIPPED,
    label: getPaymentStatus(OrderStatus.SHIPPED),
  },
  {
    value: OrderStatus.DELIVERED,
    label: getPaymentStatus(OrderStatus.DELIVERED),
  },
  {
    value: OrderStatus.CANCELED,
    label: getPaymentStatus(OrderStatus.CANCELED),
  },
];

export const phoneOrderStatusFilterSelector: SelectOption[] = [
  { value: "none", label: "All" },
  {
    value: OrderStatus.PENDING,
    label: getPaymentStatus(OrderStatus.PENDING),
  },
  {
    value: OrderStatus.PAID,
    label: getPaymentStatus(OrderStatus.PAID),
  },
  {
    value: OrderStatus.CANCELED,
    label: getPaymentStatus(OrderStatus.CANCELED),
  },
  {
    value: OrderStatus.PACKED,
    label: getPaymentStatus(OrderStatus.PACKED),
  },

  {
    value: OrderStatus.SHIPPED,
    label: getPaymentStatus(OrderStatus.SHIPPED),
  },
  {
    value: OrderStatus.DELIVERED,
    label: getPaymentStatus(OrderStatus.DELIVERED),
  },
];

export const skinTypeSelector: SelectOption[] = [
  { value: "normal skin", label: "normal skin" },
  {
    value: "dry skin",
    label: "dry skin",
  },
  {
    value: "oily skin",
    label: "oily skin",
  },
  {
    value: "sensitive skin",
    label: "sensitive skin",
  },
  {
    value: "combination skin",
    label: "combination skin",
  },
  {
    value: "all skin types",
    label: "all skin types",
  },
];
